import React from "react";
import { QueryRenderer } from "@cubejs-client/react";
import { Spin } from "antd";
import { AutoComplete } from "antd";
import cubejsApi from "../../cubejsApiBQ";

const searchCdt = ({ resultSet, props }) => {
    var dataSource = [];
    var asesor = "";
    var cedulas = [];
    resultSet.loadResponse.data.map((result, index) => {
        cedulas[index] = result["ResumenActividadCdt.identificacionAsesor"];

        return (dataSource[index] = result["Usuarios.nombre"]);
    });

    if (props.cargo) {
        asesor = props.nombre;
        const cedula = cedulas[dataSource.indexOf(props.nombre)];
        props.setCedula(cedula);
    }

    return (
        <AutoComplete
            style={{
                width: "100%",
                marginBottom: "25px",
            }}
            disabled={props.cargo}
            allowClear
            size="large"
            dataSource={dataSource}
            placeholder="Asesor"
            defaultValue={asesor}
            filterOption={(inputValue, option) => {
                return (
                    option.props.children
                        .toUpperCase()
                        .indexOf(inputValue.toUpperCase()) !== -1
                );
            }}
            onSelect={(value) => {
                props.setCedula(cedulas[dataSource.indexOf(value)]);
            }}
            onSearch={() => {
                props.setCedula("");
                props.setOficina("");
            }}
        />
    );
};

const renderChart = (Component, props) => ({ resultSet, error }) =>
    (resultSet && <Component resultSet={resultSet} props={props} />) || (
        <Spin />
    );

const SearchCdt = (props) => (
    <QueryRenderer
        query={{
            renewQuery: true,
            measures: [],
            timeDimensions: [],
            dimensions: [
                "Usuarios.nombre",
                "ResumenActividadCdt.identificacionAsesor",
            ],
            segments: [],
            filters: [
                {
                    dimension: "Usuarios.producto",
                    operator: "contains",
                    values: ["CDT"],
                },
                {
                    dimension: "Usuarios.zona",
                    operator: "contains",
                    values: props.zona !== "" ? [props.zona] : [],
                },
            ],
        }}
        cubejsApi={cubejsApi}
        render={renderChart(searchCdt, props)}
    />
);

export default SearchCdt;
